<template>
  <LegalDocumentPage :document="privacyPolicy" @close="$emit('close')" />
</template>

<script setup lang="ts">
import { privacyPolicy } from "../../content/legalDocuments";
import LegalDocumentPage from "../LegalDocumentPage.vue";

defineEmits<{
  (event: "close"): void;
}>();
</script>
